export default "__VITE_ASSET__b6903458__"